import { useTranslation } from 'react-i18next';
import type { ISelectionBarProps } from './ISelectionBarProps';

/**
 * Смуга дій з вибраним над поданням (UIUX tables/selection-and-bulk-actions, прототип v4): липка, акцентні рамка й тло; «Вибрано: N»,
 * «Вибрати все», «Зняти вибір» · «Копіювати», «Експорт», «Друк», «Змінити статус», «Видалити» (небезпечна). Копіювання й зміна статусу —
 * з можливістю `edit`, видалення — з `delete` (без права — сховані).
 */
export function SelectionBar({ count, actions, canExport, canEdit, canDelete }: ISelectionBarProps) {
  const { t } = useTranslation();
  if (count === 0) return null;
  return (
    <div className="lv-selbar" role="toolbar" aria-label={t('listbar.selection')}>
      <span className="lv-selbar__label">{t('listbar.selected', { count })}</span>
      {!actions.allSelected && <button type="button" className="lv-tbtn" disabled={actions.busy} onClick={actions.selectAll}>{t('listbar.selectAll')}</button>}
      <button type="button" className="lv-tbtn" onClick={actions.clear}>{t('listbar.deselect')}</button>
      <span className="lv-selbar__sep" aria-hidden="true" />
      {canEdit && <button type="button" className="lv-tbtn" disabled={actions.busy} onClick={actions.copy}>{t('listbar.copy')}</button>}
      <button type="button" className="lv-tbtn" disabled={actions.busy || !canExport} title={canExport ? undefined : t('listViews.noExport')} onClick={actions.exportCsv}>{t('listbar.export')}</button>
      <button type="button" className="lv-tbtn" onClick={actions.print}>{t('listbar.print')}</button>
      {canEdit && <button type="button" className="lv-tbtn" onClick={actions.bulkStatus}>{t('listbar.changeStatus')}</button>}
      {canDelete && <button type="button" className="lv-tbtn lv-tbtn--danger" onClick={actions.remove}>{t('listbar.delete')}</button>}
    </div>
  );
}
